module.exports = __webpack_public_path__ + "img/dining-dark-oak.12a42fb7.webp";